import {
  useChangeUserSubscriptionStatus,
  useGetMyDetails,
  useSubscribeToUser,
  useUnsubscribeFromUser,
} from '../../../../services/redux/api/usersApi';
import { RelationStatus } from '../../../../shared/constants';
import { IUser } from '../../../../types/interfaces/user';
import { useChangeCommunitySubscriptionStatus } from '../../../../services/redux/api/communitiesApi';

export function useUserBigItem(
  user: IUser,
  showStatusButton: boolean,
  communityId?: string,
) {
  const { data: myUser } = useGetMyDetails();
  const [changeUserSubscriberStatus] = useChangeUserSubscriptionStatus();
  const [changeCommunitySubscriberStatus] =
    useChangeCommunitySubscriptionStatus();
  const [subscribeToUser] = useSubscribeToUser();
  const [unsubscribeFromUser] = useUnsubscribeFromUser();
  const mySubscriptionToUserRelation = myUser?.subscriptions?.find(
    (s) => s.toUserId === user.id,
  );

  const subscriberToMeRelation = communityId
    ? user?.subscriptions?.find((s) => s.toCommunityId === communityId)
    : myUser?.subscriptions?.find((s) => s.toUserId === user.id);

  function onSubscribe(userId: string) {
    subscribeToUser({ id: userId }).catch((e) => console.log(e));
  }

  function onUnsubscribe(userId: string) {
    unsubscribeFromUser({ id: userId }).catch((e) => console.log(e));
  }

  function onSubscriptionStatusChange(userId: string, status: RelationStatus) {
    if (communityId) {
      changeCommunitySubscriberStatus({
        id: communityId,
        body: { status, userId },
      }).catch((e) => {
        console.log(e);
      });
    } else {
      changeUserSubscriberStatus({ id: userId, body: { status } }).catch(
        (e) => {
          console.log(e);
        },
      );
    }
  }

  function getSubscribeActions(): (
    | 'subscribe'
    | 'unsubscribe'
    | 'approve'
    | 'reject'
    | 'dropFromSubscribers'
  )[] {
    const result = [];

    if (!communityId && !mySubscriptionToUserRelation) {
      result.push('subscribe');
    }

    if (
      !communityId &&
      (mySubscriptionToUserRelation?.status === RelationStatus.approved ||
        mySubscriptionToUserRelation?.status === RelationStatus.requested)
    ) {
      result.push('unsubscribe');
    }

    if (
      showStatusButton &&
      subscriberToMeRelation?.status === RelationStatus.approved
    ) {
      result.push('dropFromSubscribers');
    }

    if (
      showStatusButton &&
      subscriberToMeRelation?.status === RelationStatus.requested
    ) {
      result.push('approve');
      result.push('reject');
    }

    if (
      showStatusButton &&
      subscriberToMeRelation?.status === RelationStatus.rejected
    ) {
      result.push('approve');
    }

    return result;
  }

  return {
    onSubscribe,
    onUnsubscribe,
    onSubscriptionStatusChange,
    subscribeActions: getSubscribeActions(),
  };
}
